module.exports = __webpack_public_path__ + "img/flop10FilterOn.cfd959ad.svg";